import { useEffect, useState } from 'react';
import { Dimensions, Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Animated, {
  FadeInUp,
  FadeOutUp,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import Svg, { Path } from 'react-native-svg';

// --- ICONS & STAR RATING COMPONENTS ---

const PlusIcon = () => (
  <Svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <Path
      d="M1 6H11M6 1V11"
      stroke="rgba(255, 255, 255, 0.7)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

const HeartIcon = () => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3212 8.60875H15.2712C14.9546 8.60875 14.6796 8.35875 14.6546 8.03371C14.6046 7.40037 14.1712 6.85871 13.5712 6.65871C13.2379 6.55037 13.0629 6.20037 13.1629 5.87537C13.2712 5.54204 13.6296 5.36704 13.9546 5.47537C15.0462 5.82537 15.8046 6.79204 15.8962 7.93371C15.9212 8.27537 15.6712 8.57542 15.3212 8.60875ZM17.9046 5.81704C17.3379 4.41704 16.2462 3.39204 14.8296 2.93371C14.0546 2.68371 13.2129 2.62537 12.3962 2.76704C11.6546 2.89204 10.9796 3.33371 10.4129 3.75037C9.87124 3.35037 9.17957 2.90037 8.42957 2.77537C7.62127 2.64204 6.78794 2.69204 6.00461 2.93371C2.89627 3.94204 1.93794 7.34204 2.81294 10.0504C4.16294 14.3921 9.99624 17.1504 10.2379 17.2671C10.2962 17.2921 10.3546 17.3087 10.4129 17.3087C10.4796 17.3087 10.5379 17.2921 10.5879 17.2671C10.8379 17.1587 16.5796 14.4421 18.0129 10.0504C18.4712 8.62542 18.4296 7.11704 17.9046 5.81704Z"
      fill="#34A853"
    />
  </Svg>
);

const ThumbsUpIcon = () => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8475 10.0902C17.6804 9.47442 17.2757 8.95542 16.7391 8.62992C16.1409 8.27802 15.27 8.27802 13.5282 8.27802H12.5957C12.4637 8.27802 12.4022 8.27802 12.3582 8.25162C12.3246 8.23147 12.3012 8.20104 12.2882 8.16819C12.2802 8.14822 12.2736 8.12713 12.2735 8.10564C12.2733 8.06122 12.2971 7.99691 12.3317 7.89974C13.4842 4.30176 12.5869 2.91183 11.4432 2.67432C11.3113 2.64792 11.1354 2.63912 10.9507 2.63912C10.7043 2.63033 10.5812 2.63033 10.4492 2.68311C10.3261 2.7183 10.1941 2.79747 10.1062 2.88544C10.0006 2.99101 9.93016 3.12297 9.79824 3.38687C9.29582 4.37491 8.33916 6.14397 7.45167 7.23761C7.37021 7.33798 7.34831 7.47304 7.38316 7.59752C7.50222 8.02268 7.50222 8.48067 7.50222 9.09617V15.386C7.50222 15.7239 7.50222 16.0168 7.47967 16.2838C7.4668 16.4361 7.54197 16.5852 7.67843 16.654L8.35549 16.9958C8.61941 17.1278 8.76016 17.1982 8.90091 17.251C9.02407 17.2949 9.16482 17.3213 9.29682 17.3478C9.44632 17.3653 9.59591 17.3653 9.89499 17.3653H13.6513C14.575 17.3653 15.0325 17.3653 15.4196 17.207C15.7802 17.0663 16.0881 16.8288 16.3257 16.5208C16.5719 16.1865 16.6951 15.7379 16.9327 14.8494L17.3549 13.2748C17.8123 11.5945 18.0411 10.75 17.8475 10.0902Z"
      fill="#FDB320"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.49723 7.24915C5.23332 7.11719 4.89023 7.11719 4.20407 7.11719H4.07211C3.37714 7.11719 3.03406 7.11719 2.77015 7.24915C2.53263 7.3723 2.3391 7.56584 2.21594 7.80335C2.08398 8.06726 2.08398 8.41034 2.08398 9.0965V15.3864C2.08398 16.0726 2.08398 16.4157 2.21594 16.6796C2.3391 16.9171 2.53263 17.1194 2.77015 17.2338C3.03406 17.3658 3.37714 17.3658 4.07211 17.3658H4.20407C4.89023 17.3658 5.23332 17.3658 5.49723 17.2338C5.73475 17.1194 5.92828 16.9171 6.05144 16.6796C6.18339 16.4157 6.18339 16.0726 6.18339 15.3864V9.0965C6.18339 8.41034 6.18339 8.06726 6.05144 7.80335C5.92828 7.56584 5.73475 7.3723 5.49723 7.24915Z"
      fill="#FDB320"
    />
  </Svg>
);

const ThumbsDownIcon = () => (
  <Svg width="20" height="20" viewBox="0 0 20 20" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.36875 12.0259H7.04901C7.33782 12.0259 7.53322 12.3532 7.43885 12.6262C6.86355 14.2904 6.69976 17.6945 9.48915 17.7493C9.53324 17.7502 9.57924 17.7424 9.62007 17.7257C10.0395 17.5544 10.1446 17.3418 10.2328 16.9269C10.7951 14.3925 12.0204 12.9949 13.1359 12.4432C13.1972 12.4129 13.2133 12.3367 13.1827 12.2755C12.8313 11.6283 12.8313 10.9994 12.8313 9.95452V4.82223C12.8313 4.34567 12.8313 3.95369 12.8666 3.60665C12.8835 3.43946 12.7992 3.27459 12.6457 3.20597C11.8639 2.85621 11.0484 2.55664 10.2328 2.55664H6.10853C3.73197 2.55664 2.08594 4.10094 2.08594 6.6532C2.08594 9.32569 1.89175 12.0259 5.36875 12.0259Z"
      fill="#EA4335"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1878 12.3314C15.479 12.4655 16.4491 12.4914 17.3183 12.4969C17.6485 12.4988 17.9157 12.2307 17.9157 11.9014V2.84553C17.9157 2.5154 17.6485 2.24816 17.3183 2.25001C16.4491 2.25463 15.479 2.28053 15.1878 2.41553C14.8456 2.57273 14.5682 2.82242 14.4017 3.13683C14.2168 3.46973 14.2168 3.9136 14.2168 4.79209V9.95483C14.2168 10.8333 14.2168 11.2773 14.4017 11.6102C14.5682 11.9245 14.8456 12.1743 15.1878 12.3314Z"
      fill="#EA4335"
    />
  </Svg>
);

const Star = ({ isFilled, isHalfFilled }) => {
  if (isHalfFilled) {
    return (
      <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <Path
          d="M8 1L10.163 5.38197L15 6.12322L11.5 9.54503L12.326 14.3607L8 12.082L3.674 14.3607L4.5 9.54503L1 6.12322L5.837 5.38197L8 1Z"
          fill="rgba(255, 255, 255, 0.15)"
        />
        <Path
          d="M8 1L10.163 5.38197L15 6.12322L11.5 9.54503L12.326 14.3607L8 12.082L3.674 14.3607L4.5 9.54503L1 6.12322L5.837 5.38197L8 1Z"
          stroke="#FF7B00"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <Path
        d="M8 1L10.163 5.38197L15 6.12322L11.5 9.54503L12.326 14.3607L8 12.082L3.674 14.3607L4.5 9.54503L1 6.12322L5.837 5.38197L8 1Z"
        fill={isFilled ? '#FF7B00' : 'rgba(255, 255, 255, 0.15)'}
      />
    </Svg>
  );
};

const StarRating = ({ rating }) => (
  <View style={styles.starRatingContainer}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        isFilled={i <= Math.floor(rating)}
        isHalfFilled={i === Math.ceil(rating) && rating % 1 !== 0}
      />
    ))}
  </View>
);

// --- HELPER FUNCTIONS ---

const getFitIcon = (valueType) => {
  switch (valueType) {
    case 'normal':
      return <HeartIcon />;
    case 'warning':
      return <ThumbsUpIcon />;
    case 'bad':
      return <ThumbsDownIcon />;
    default:
      return <HeartIcon />;
  }
};

const getFitLabel = (valueType) => {
  switch (valueType) {
    case 'normal':
      return 'Great Fit';
    case 'warning':
      return 'Good Fit';
    case 'bad':
      return 'Poor Fit';
    default:
      return 'Great Fit';
  }
};

// --- REUSABLE STRUCTURED CONTENT COMPONENTS ---

const MetricItem = ({ label, value, context, valueType = 'normal', isMobile = false }) => (
  <View style={[styles.metricItem, isMobile && styles.metricItemMobile]}>
    <View style={[styles.metricContent, isMobile && styles.metricContentMobile]}>
      <Text style={styles.metricLabel}>{label}</Text>
      <Text style={styles.metricValue}>{value}</Text>
      <Text style={styles.metricContext}>{context}</Text>
    </View>
    <View style={styles.metricFooter}>
      {getFitIcon(valueType)}
      <Text style={styles.metricFooterText}>{getFitLabel(valueType)}</Text>
    </View>
  </View>
);

const MetricsGrid = ({ metrics, isMobile = false }) => (
  <View style={[styles.metricsGrid, isMobile && styles.metricsGridMobile]}>
    {metrics.map((metric, index) => (
      <MetricItem key={index} {...metric} isMobile={isMobile} />
    ))}
  </View>
);

// --- MODIFIED ACCORDION ITEM (UNCHANGED) ---

const AccordionItem = ({ item, isOpen, onClick, isFirst, isLast, isMobile = false }) => {
  const getBorderRadiusStyle = () => {
    if (isFirst) return { borderTopLeftRadius: 16, borderTopRightRadius: 16 };
    if (isLast) return { borderBottomLeftRadius: 16, borderBottomRightRadius: 16 };
    return {};
  };

  const rotationStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: withTiming(isOpen ? '45deg' : '0deg', { duration: 300 }) }],
  }));

  return (
    <View
      style={[
        styles.accordionItem,
        getBorderRadiusStyle(),
        !isFirst && { marginTop: 4 },
        isOpen && isFirst && { borderBottomLeftRadius: 2, borderBottomRightRadius: 2 },
        !isOpen && isLast && { borderTopLeftRadius: 8, borderTopRightRadius: 8 },
        isOpen && isLast && { borderTopLeftRadius: 2, borderTopRightRadius: 2 },
      ]}
    >
      <TouchableOpacity onPress={onClick} style={styles.accordionHeader}>
        <View style={styles.headerLeft}>
          <Text style={isOpen ? styles.cardTitleOpen : styles.cardTitle}>{item.title}</Text>
          <StarRating rating={item.rating} />
        </View>
        <Animated.View style={[styles.plusButton, rotationStyle]}>
          <PlusIcon />
        </Animated.View>
      </TouchableOpacity>
      {isOpen && (
        <Animated.View
          entering={FadeInUp.duration(300)}
          exiting={FadeOutUp.duration(300)}
          style={styles.contentContainer}
        >
          {item.content ? (
            <>
              <Text style={styles.analysisText}>{item.content.user_fit_analysis}</Text>
              <MetricsGrid metrics={item.content.key_metrics} isMobile={isMobile} />
              <View style={styles.verdictContainer}>
                <Text style={styles.verdictLabel}>Final verdict:</Text>
                <Text style={styles.verdictText}>{item.content.match_statement}</Text>
              </View>
            </>
          ) : (
            <Text style={styles.cardDescription}>{item.description}</Text>
          )}
        </Animated.View>
      )}
    </View>
  );
};

const DEFAULT_TITLE = 'Why this car fits your lifestyle';

// --- FULLY TRANSFORMED DATA FOR ALL SIX ACCORDIONS ---
const DEFAULT_ITEMS = [
  {
    title: 'The Driving Experience',
    rating: 5,
    content: {
      match_statement:
        'An excellent match, offering the blend of comfort and performance you want for long trips.',
      key_metrics: [
        {
          label: 'Engine (530d)',
          value: '3.0L 6-Cylinder Diesel',
          context: '190 kW & 560 Nm of torque for effortless cruising.',
        },
        { label: '0-100 km/h', value: '5.9 seconds', context: 'Strong, responsive performance.' },
        {
          label: 'Suspension',
          value: 'Advanced Multi-link',
          context: 'Self-levelling rear air suspension ensures comfort.',
        },
      ],
      user_fit_analysis:
        "This car is renowned for its dynamic yet comfortable ride, making it a perfect companion for the long-distance European travel you've planned. It delivers the refined driving experience you're looking for.",
    },
  },
  {
    title: 'Real-World Practicality',
    rating: 5,
    content: {
      match_statement:
        'An outstanding fit, perfectly matching your needs for passengers, cargo, and towing.',
      key_metrics: [
        {
          label: 'Boot Volume',
          value: '560 L / 1670 L',
          context: 'Above average and ideal for long trips and luggage.',
        },
        {
          label: 'Passengers',
          value: 'Comfortably seats 4',
          context: 'Aligns with your typical need for 3-4 people.',
        },
        {
          label: 'Towing Capacity',
          value: '2000 kg',
          context: 'Meets your occasional towing requirements.',
        },
      ],
      user_fit_analysis:
        "From its spacious interior to its large, flexible cargo area and useful towing capacity, this vehicle excels in every practical area you require. It's an ideal choice for your lifestyle.",
    },
  },
  {
    title: 'Interior, Comfort & Technology',
    rating: 4.5,
    content: {
      match_statement:
        'Well-equipped for its era, with key luxury and tech features available as options.',
      key_metrics: [
        {
          label: 'Infotainment',
          value: 'iDrive 10.25-inch',
          context: 'Advanced for its time with Professional Navigation.',
        },
        {
          label: 'Key Options',
          value: 'Available',
          context: 'Panoramic roof, memory seats, Harman Kardon sound.',
        },
        {
          label: 'Driver Aids (ADAS)',
          value: 'Optional Package',
          context: "Look for 'Driving Assistant Plus' for cruise/lane features.",
        },
      ],
      user_fit_analysis:
        'The car meets your core needs with standard leather and PDC. To get the full suite of modern tech and comfort, you will need to find a model equipped with the right optional packages.',
    },
  },
  {
    title: 'Safety in Context',
    rating: 4,
    content: {
      match_statement:
        'Excellent crash protection for its era, though it lacks the latest active avoidance tech.',
      key_metrics: [
        {
          label: 'Euro NCAP Rating',
          value: '5 Stars',
          context: 'High scores for adult (95%) and child (83%) protection.',
        },
        {
          label: 'Standard Safety',
          value: 'Good',
          context: 'Includes DSC and multiple airbags as standard.',
        },
        {
          label: 'Active Avoidance',
          value: 'Optional',
          context: 'Advanced systems available, but not standard.',
          valueType: 'warning',
        },
      ],
      user_fit_analysis:
        'While its structural integrity is top-tier for its time, the most advanced safety features that actively prevent collisions were optional extras. This represents the main trade-off compared to a brand-new vehicle.',
    },
  },
  {
    title: 'Long-Term Ownership & Costs',
    rating: 4,
    content: {
      match_statement:
        'Financially sound with a strong reliability record, but inspect the rear air suspension.',
      key_metrics: [
        {
          label: 'Budget Alignment',
          value: 'Perfect Fit',
          context: '€21k-€28k price is within your €20k-€30k budget.',
        },
        {
          label: 'Est. Monthly Costs',
          value: '€90 - €150',
          context: "Considered 'Manageable' and aided by diesel efficiency.",
        },
        {
          label: 'Key Inspection Point',
          value: 'Rear Air Suspension',
          context: 'Check for wear on Touring models at high mileage.',
          valueType: 'warning',
        },
      ],
      user_fit_analysis:
        'This model is a smart choice from an ownership perspective. Its reputation is solid, but a pre-purchase inspection of the rear air suspension is highly recommended to avoid a common and costly repair.',
    },
  },
  {
    title: 'Powertrain & Environmental Fit',
    rating: 5,
    content: {
      match_statement:
        'The diesel engine is a perfect fit for your high-mileage, highway-focused driving.',
      key_metrics: [
        {
          label: 'Engine Type',
          value: 'Turbocharged Diesel',
          context: 'Ideal for your 20k-30k km annual distance.',
        },
        {
          label: 'Key Pro',
          value: 'Excellent Efficiency',
          context: 'Low fuel consumption (e.g., 4.7 L/100km) on long trips.',
        },
        {
          label: 'Key Con',
          value: 'DPF Maintenance',
          context: 'Not an issue for you, but requires regular highway runs.',
          valueType: 'warning',
        },
      ],
      user_fit_analysis:
        'This powertrain choice is highly logical for your use case. It provides the torque and fuel economy needed for effortless long-distance travel, aligning perfectly with your driving plans.',
    },
  },
];

const ProductInfo = ({ title = DEFAULT_TITLE, items = DEFAULT_ITEMS }) => {
  const [openItems, setOpenItems] = useState(() => items.map((_, i) => i)); // Default to opening all items

  // Track screen width for responsive layout
  const [screenWidth, setScreenWidth] = useState(Dimensions.get('window').width);
  const BREAKPOINT_WIDTH = 768;

  useEffect(() => {
    const subscription = Dimensions.addEventListener('change', ({ window }) => {
      setScreenWidth(window.width);
    });
    return () => subscription?.remove();
  }, []);

  const isMobile = screenWidth < BREAKPOINT_WIDTH;

  const toggleItem = (index) => {
    setOpenItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  return (
    <View style={[styles.container, isMobile && styles.containerMobile]}>
      <Text style={styles.mainTitle}>{title}</Text>
      <View style={styles.accordionContainer}>
        {items.map((item, index) => (
          <AccordionItem
            key={index}
            item={item}
            isOpen={openItems.includes(index)}
            onClick={() => toggleItem(index)}
            isFirst={index === 0}
            isLast={index === items.length - 1}
            isMobile={isMobile}
          />
        ))}
      </View>
    </View>
  );
};

// --- STYLES ---
const styles = StyleSheet.create({
  container: { width: 812, flexDirection: 'column', gap: 30 },
  containerMobile: { width: '100%' },
  mainTitle: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 16,
    lineHeight: 24 * 1.6,
    color: 'rgba(255, 255, 255, 0.5)',
  },
  accordionContainer: { flexDirection: 'column' },
  accordionItem: {
    backgroundColor: '#1D242F',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.08)',
    padding: 24,
  },
  accordionHeader: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' },
  headerLeft: { flexDirection: 'column', gap: 8, flex: 1 },
  cardTitle: { fontFamily: 'Satoshi-Medium', fontSize: 16, lineHeight: 16 * 1.4, color: 'rgba(255, 255, 255, 0.85)' },
  cardTitleOpen: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 16,
    lineHeight: 16 * 1.4,
    color: '#FFFFFF',
  },
  cardDescription: {
    fontFamily: 'Satoshi-Regular',
    fontSize: 16,
    lineHeight: 16 * 1.6,
    color: 'rgba(255, 255, 255, 0.6)',
    marginTop: 16,
  },
  starRatingContainer: { flexDirection: 'row', gap: 4 },
  plusButton: {
    width: 16,
    height: 16,
    opacity: 0.5,
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentContainer: { marginTop: 16 },
  verdictContainer: { flexDirection: 'column', gap: 4 },
  verdictLabel: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 16,
    lineHeight: 16 * 1.4,
    color: '#FFFFFF',
  },
  verdictText: {
    fontFamily: 'Satoshi-Regular',
    fontSize: 16,
    lineHeight: 16 * 1.6,
    color: 'rgba(255, 255, 255, 0.6)',
  },
  metricsGrid: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20, gap: 12 },
  metricsGridMobile: { flexDirection: 'column' },
  metricItem: {
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.1)',
    padding: 16,
    borderRadius: 8,
    flex: 1,
    justifyContent: 'space-between',
  },
  metricItemMobile: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
    justifyContent: 'flex-start',
  },
  metricContent: { flex: 1 },
  metricContentMobile: {
    flexGrow: 0,
    flexShrink: 0,
    flexBasis: 'auto',
  },
  metricLabel: { fontFamily: 'Satoshi-Bold', fontSize: 14, color: '#5B8DEF', marginBottom: 0 },
  metricValue: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 16,
    lineHeight: 22,
    color: '#FFFFFF',
    marginBottom: 16,
  },
  metricContext: {
    fontFamily: 'Satoshi-Regular',
    fontSize: 14,
    color: 'rgba(255, 255, 255, 0.55)',
    marginTop: 4,
  },
  metricFooter: { flexDirection: 'row', alignItems: 'center', gap: 6, marginTop: 16 },
  metricFooterText: {
    fontFamily: 'Satoshi-Medium',
    fontSize: 12,
    color: 'rgba(255, 255, 255, 0.6)',
    lineHeight: 20,
  },
  analysisText: {
    fontFamily: 'Satoshi-Regular',
    fontSize: 16,
    lineHeight: 16 * 1.6,
    color: 'rgba(255, 255, 255, 0.7)',
    marginTop: 8,
    paddingBottom: 20,
  },
});

export default ProductInfo;
